export default __webpack_public_path__ + "static/media/calendar.ae97c2bf.svg";